<template>
  <div class="page">
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="card">
          <div class="card-content">
            <p class="title">An unexpected error has occurred</p>
            <p class="subtitle">Please try again by navigating to another page or refreshing.</p>
            <p class="is-size-7">Details: {{ error }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const error = computed(() => store.getters.error);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page {
  padding-top: 10%;
}
</style>
